import React from "react";
import { StyleSheet, TouchableOpacity, View, Pressable } from "react-native";

//Custom Imports
import { scale } from "@utils/scale";
import color from "@constants/color";
import t from "@constants/localization";
import RightArrow from "@assets/svg/RightArrow";
import CustomText from "@components/CustomText";
import { getDayMonthYear } from "@utils/getFormattedDate";
import { CONTEST_EVENTS } from "@constants/analyticsEventsCT";

const PATH = "screens/Contest";

const AlreadyOrderedCustomers = ({
  item = {},
  onPressOrder = () => {},
  contestEvents = () => {},
  navigation = {},
}) => {
  const {
    user_name = "",
    sale,
    commission,
    order_details = {},
    cx_id = "",
  } = item || {};

  const navigateToCxPage = () => {
    if (cx_id && navigation) {
      navigation.navigate("CustomerProfile", {
        user: { user_id: cx_id },
        fetchProfile: true,
      });
    }
    contestEvents(CONTEST_EVENTS.CX_NAME_CLICKED, {
      screen: "Ordered task page",
      order_id: order_details?.order_id,
      user_id: cx_id,
    });
  };

  return (
    <Pressable
      onPress={() =>
        contestEvents(CONTEST_EVENTS.ORDER_CLICKED, {
          screen: "Ordered task page",
          cart_value: order_details?.total_cart_value,
          cart_items: order_details?.items?.length,
          order_id: order_details?.order_id,
        })
      }
      style={styles.cardContainer}
    >
      <Pressable onPress={navigateToCxPage}>
        <CustomText
          variant="subtitle_16"
          newfont={true}
          numberOfLines={1}
          style={styles.orderedText}
        >
          {user_name}
        </CustomText>
      </Pressable>
      {order_details?.created_at ? (
        <View style={styles.dateContainer}>
          <CustomText
            variant="body_text_3"
            newfont={true}
            numberOfLines={1}
            style={styles.orderedText}
          >
            {`${t(`${PATH}/orderedOn`)} `}
          </CustomText>
          <CustomText
            variant="body_text_4"
            newfont={true}
            numberOfLines={1}
            style={styles.orderedText}
          >
            {getDayMonthYear(order_details.created_at)}
          </CustomText>
        </View>
      ) : null}
      <TouchableOpacity
        activeOpacity={0.8}
        onPress={() => {
          if (
            Array.isArray(order_details?.items) &&
            order_details.items.length !== 0
          ) {
            onPressOrder(item);
            contestEvents(CONTEST_EVENTS.CART_VIEWED, {
              screen: "Ordered task page",
              cart_value: order_details?.total_cart_value,
              cart_items: order_details?.items?.length,
              order_id: order_details?.order_id,
            });
          }
        }}
        style={styles.orderCountContainer}
      >
        <View style={styles.saleComiContainer}>
          <View>
            <CustomText
              variant="body_text_3"
              newfont={true}
              numberOfLines={1}
              style={styles.orderedText}
            >
              {t(`${PATH}/sale`)}
            </CustomText>
            <CustomText
              variant="body_text_4"
              newfont={true}
              numberOfLines={1}
              style={styles.orderedText}
            >
              {order_details?.total_cart_value
                ? `₹${parseInt(order_details.total_cart_value)}`
                : ""}
            </CustomText>
          </View>
          <View>
            <CustomText
              variant="body_text_3"
              newfont={true}
              numberOfLines={1}
              style={styles.orderedText}
            >
              {t(`${PATH}/commission`)}
            </CustomText>
            <CustomText
              variant="body_text_4"
              newfont={true}
              numberOfLines={1}
              style={styles.orderedText}
            >
              {order_details?.expected_commission !== undefined
                ? `₹${parseFloat(order_details.expected_commission).toFixed(2)}`
                : ""}
            </CustomText>
          </View>
        </View>
        <View style={styles.itemContainer}>
          <CustomText
            variant="body_text_3"
            newfont={true}
            numberOfLines={1}
            style={[styles.orderedText, { marginEnd: 12 }]}
          >
            {`${order_details?.items?.length} ${t(`${PATH}/items`)}`}
          </CustomText>
          <RightArrow fill={color.primary} stroke={color.primary} />
        </View>
      </TouchableOpacity>
    </Pressable>
  );
};

export default AlreadyOrderedCustomers;

const styles = StyleSheet.create({
  cardContainer: {
    flexDirection: "column",
    elevation: 8,
    shadowColor: color.mediumBlack,
    shadowOffset: { width: 2, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4.65,
    borderRadius: scale(10),
    backgroundColor: color.white,
    marginTop: 14,
    paddingHorizontal: 16,
    paddingTop: 12,
    paddingBottom: 16,
  },
  orderedText: {
    color: color.mediumBlack,
  },
  dateContainer: {
    flexDirection: "row",
    marginTop: 4,
  },
  orderCountContainer: {
    backgroundColor: "rgba(192, 110, 53, 0.05)",
    borderRadius: 10,
    marginTop: 10,
    flexDirection: "row",
    paddingHorizontal: 16,
    paddingVertical: 14,
    alignItems: "center",
  },
  saleComiContainer: {
    flexDirection: "row",
    flex: 0.5,
    alignItems: "center",
    justifyContent: "space-between",
  },
  itemContainer: {
    flex: 0.5,
    justifyContent: "flex-end",
    alignItems: "center",
    flexDirection: "row",
  },
});
